import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { Search, Loader2 } from "lucide-react";

export function GlobalSearch() {
  const navigate = useNavigate();
  const [q, setQ] = useState("");
  const [res, setRes] = useState(null);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const ref = useRef();
  const timer = useRef();

  useEffect(() => {
    const onClick = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  const onChange = (e) => {
    const v = e.target.value; setQ(v); setOpen(true);
    clearTimeout(timer.current);
    if (v.trim().length < 1) { setRes(null); return; }
    setLoading(true);
    timer.current = setTimeout(async () => {
      try { const { data } = await api.get(`/search?q=${encodeURIComponent(v)}`); setRes(data); } catch (e) {}
      setLoading(false);
    }, 300);
  };

  const groups = res ? [
    ["Work Orders", res.work_orders], ["Properties", res.properties],
    ["Invoices", res.invoices], ["Contractors", res.contractors],
  ].filter(([, arr]) => arr && arr.length) : [];

  const go = (item) => { setOpen(false); setQ(""); setRes(null); if (item.link) navigate(item.link); };

  return (
    <div className="relative" ref={ref}>
      <div className="relative">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
        <input data-testid="global-search" value={q} onChange={onChange} onFocus={() => setOpen(true)} placeholder="Search..."
          className="w-40 md:w-64 pl-9 pr-3 h-9 rounded-lg border border-slate-200 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 bg-slate-50 focus:bg-white transition-colors" />
      </div>
      {open && q.trim().length > 0 && (
        <div className="absolute right-0 mt-2 w-80 max-h-96 overflow-y-auto bg-white border border-slate-200 rounded-xl shadow-lg z-50">
          {loading ? <div className="p-6 flex justify-center"><Loader2 className="w-4 h-4 animate-spin text-blue-600" /></div> :
            groups.length === 0 ? <p className="p-6 text-center text-sm text-slate-400">No results.</p> :
              groups.map(([label, arr]) => (
                <div key={label}>
                  <div className="px-4 pt-3 pb-1 text-[10px] uppercase font-bold text-slate-400">{label}</div>
                  {arr.map((item) => (
                    <button key={item.id} data-testid={`search-result-${item.id}`} onClick={() => go(item)} disabled={!item.link} className="w-full text-left px-4 py-2 hover:bg-slate-50 disabled:opacity-60">
                      <div className="text-sm font-medium text-slate-900">{item.label}</div>
                      <div className="text-xs text-slate-500">{item.sub}</div>
                    </button>
                  ))}
                </div>
              ))}
        </div>
      )}
    </div>
  );
}
